<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="title">Contents</p>
<p class="toc"><span href="#/chap01" title="Link target outside of Sample">Ghost</span></p>
<p class="toc"><span href="#/chap02" title="Link target outside of Sample">Travel</span></p>
<p class="toc"><span href="#/chap03" title="Link target outside of Sample">Heave</span></p>
<p class="toc"><span href="#/chap04" title="Link target outside of Sample">Ghost</span></p>
<p class="toc"><span href="#/chap05" title="Link target outside of Sample">Rider</span></p>
<p class="toc"><span href="#/chap06" title="Link target outside of Sample">Ghost</span></p>
<p class="toc"><span href="#/chap07" title="Link target outside of Sample">And over her spinning rainbow</span></p>
<p class="toc"><span href="#/chap08" title="Link target outside of Sample">Travel</span></p>
<p class="toc"><span href="#/chap09" title="Link target outside of Sample">Zipaquirá Salt Mine</span></p>
<p class="toc"><span href="#/chap10" title="Link target outside of Sample">Travel</span></p>
<p class="toc"><span href="#/chap11" title="Link target outside of Sample">Travel</span></p>
<p class="toc"><span href="#/chap12" title="Link target outside of Sample">South</span></p>
<p class="toc"><span href="#/chap13" title="Link target outside of Sample">To Quito</span></p>
<p class="toc"><span href="#/chap14" title="Link target outside of Sample">History</span></p>
<p class="toc"><span href="#/chap15" title="Link target outside of Sample">Market</span></p>
<p class="toc"><span href="#/chap16" title="Link target outside of Sample">Currency</span></p>
<p class="toc"><span href="#/chap17" title="Link target outside of Sample">Thread</span></p>
<p class="toc"><span href="#/chap18" title="Link target outside of Sample">Currency</span></p>
<p class="toc"><span href="#/chap19" title="Link target outside of Sample">Traces of Eva’s potato song</span></p>
<p class="toc"><span href="#/chap20" title="Link target outside of Sample">Train, Cuzco-Puno</span></p>
<p class="toc"><span href="#/chap21" title="Link target outside of Sample">Travel</span></p>
<p class="toc"><span href="#/chap22" title="Link target outside of Sample">Train, Cuzco-Puno</span></p>
<p class="toc"><span href="#/chap23" title="Link target outside of Sample">Time travel</span></p>
<p class="toc"><span href="#/chap24" title="Link target outside of Sample">The riverboat</span></p>
<p class="toc"><span href="#/chap25" title="Link target outside of Sample">Currency</span></p>
<p class="toc"><span href="#/chap26" title="Link target outside of Sample">Market</span></p>
<p class="toc"><span href="#/chap27" title="Link target outside of Sample">As if we are hemispheres folding onto each other</span></p>
<p class="toc"><span href="#/chap28" title="Link target outside of Sample">Institution, Travel</span></p>
<p class="toc"><span href="#/chap29" title="Link target outside of Sample">Travel</span></p>
<p class="toc"><span href="#/chap30" title="Link target outside of Sample">Firmament</span></p>
<p class="toc"><span href="#/chap31" title="Link target outside of Sample">Market</span></p>
<p class="toc"><span href="#/chap32" title="Link target outside of Sample">Andes</span></p>
<p class="toc"><span href="#/chap33" title="Link target outside of Sample">Hypermarket</span></p>
<p class="toc"><span href="#/chap34" title="Link target outside of Sample">Hypermarket</span></p>
<p class="toc"><span href="#/chap35" title="Link target outside of Sample">Pale</span></p>
<p class="toc"><span href="#/chap36" title="Link target outside of Sample">Covenant</span></p>
<p class="toc"><span href="#/chap37" title="Link target outside of Sample">Market</span></p>
<p class="toc"><span href="#/chap38" title="Link target outside of Sample">Sphinx</span></p>
<p class="toc"><span href="#/chap39" title="Link target outside of Sample">Learning history</span></p>
<p class="toc"><span href="#/chap40" title="Link target outside of Sample">Meridian</span></p>
<p class="toc"><span href="#/chap41" title="Link target outside of Sample">Excelling Violet</span></p>
<p class="toc"><span href="#/chap42" title="Link target outside of Sample">Excelling Violet</span></p>
<p class="toc"><span href="#/chap43" title="Link target outside of Sample">Firmament</span></p>
<p class="toc"><span href="#/chap44" title="Link target outside of Sample">Spring—</span></p>
<p class="toc"><span href="#/chap45" title="Link target outside of Sample">Iris</span></p>
<p class="toc"><span href="#/chap46" title="Link target outside of Sample">Rustling, so beautifully?</span></p>
<p class="toc"><span href="#/chap47" title="Link target outside of Sample">Galactic roses.</span></p>
<p class="toc"><span href="#/chap48" title="Link target outside of Sample">Hammer buried in white mud, bank of the Orinoco</span></p>
<p class="toc"><span href="#/chap49" title="Link target outside of Sample">Economy</span></p>
<p class="toc"><span href="#/chap50" title="Link target outside of Sample">The coca leaf fortune-teller</span></p>
<p class="toc"><span href="#/chap51" title="Link target outside of Sample">The coca leaf fortune-teller</span></p>
<p class="toc"><span href="#/chap52" title="Link target outside of Sample">Do you want to say anything here.</span></p>
<p class="toc"><span href="#/chap53" title="Link target outside of Sample"><i>Oliviera</i></span></p>
<p class="toc"><span href="#/chap54" title="Link target outside of Sample">Floating turd next to the dead floating snake</span></p>
<p class="toc"><span href="#/chap55" title="Link target outside of Sample">Ghost</span></p>
<p class="toc"><span href="#/chap56" title="Link target outside of Sample">Thread</span></p>
<p class="toc"><span href="#/chap57" title="Link target outside of Sample">What we think when we travel this river</span></p>
<p class="toc"><span href="#/chap58" title="Link target outside of Sample">Firmament</span></p>
<p class="toc"><span href="#/chap59" title="Link target outside of Sample">What we think when we travel this river</span></p>
<p class="toc"><span href="#/chap60" title="Link target outside of Sample">Sunset, Tayrona</span></p>
<p class="toc"><span href="#/chap61" title="Link target outside of Sample">The seven directions</span></p>
<p class="toc"><span href="#/chap62" title="Link target outside of Sample">Night, Tayrona</span></p>
<p class="toc"><span href="#/chap63" title="Link target outside of Sample">The coca leaf fortune-teller</span></p>
<p class="toc"><span href="#/chap64" title="Link target outside of Sample">Star-shaped hubcaps across Medellín</span></p>
<p class="toc"><span href="#/chap65" title="Link target outside of Sample">Iris, starless</span></p>
<p class="toc"><span href="#/chap66" title="Link target outside of Sample">Or to say—</span></p>
<p class="toc"><span href="#/chap67" title="Link target outside of Sample">Iris</span></p>
<p class="toc"><span href="#/chap68" title="Link target outside of Sample">Ghost</span></p>
<p class="toc"><span href="#/chap69" title="Link target outside of Sample">Ruins</span></p>
<p class="toc"><span href="#/chap70" title="Link target outside of Sample">Suspension</span></p>
<p class="toc"><span href="#/chap71" title="Link target outside of Sample">Ghost</span></p>
<p class="toc"><span href="#/chap72" title="Link target outside of Sample">The coca leaf fortune-teller</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?aa167b3e